<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="mb-2">
            <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
              ><i class="ti ti-chevrons-up"></i
            ></a>
            </div>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <attendance-policy-settings />

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Schedule Timing List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>

            <div>
              <button
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#schedule_timing"
                v-can="'ShiftSchedule.Create'"
              >
                <i class="ti ti-plus me-1"></i> Add Schedule
              </button>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <schedule-time-table
              :rows="store.rows"
              :loading="store.loading"
              @edit="openEdit"
              @delete="confirmDelete"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <schedule-time-modal :edit-item="editItem" @saved="onSaved" />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import Modal from "bootstrap/js/dist/modal";
import ScheduleTimeTable from "./schedule-time-table.vue";
import ScheduleTimeModal from "@/components/modal/schedule-time-modal.vue";
import AttendancePolicySettings from "./attendance-policy-settings.vue";
import { useScheduleStore } from "@/stores/scheduleStore";

const title = "Schedule Timing";
const text = "HR";
const text1 = "Schedule Timing";

const dateRangeInput = ref(null);
const drp = ref(null);

const store = useScheduleStore();
const editItem = ref(null);

function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    Modal.getOrCreateInstance(document.getElementById("schedule_timing"))?.show();
  });
}

async function confirmDelete(row) {
  if (!row?.id) return;
  if (!confirm("Delete this schedule?")) return;
  await store.remove(row.id);
}

function onSaved() {
  editItem.value = null;
  store.fetchList();
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function applyRange(start, end) {
  store.filters.date_from = start.format("YYYY-MM-DD");
  store.filters.date_to = end.format("YYYY-MM-DD");
  store.fetchList({ page: 1 });
}

onMounted(() => {
  const start = moment().subtract(6, "days");
  const end = moment();

  if (dateRangeInput.value) {
    drp.value = new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      (s, e) => applyRange(s, e)
    );
  }

  // initial load
  applyRange(start, end);
});

onBeforeUnmount(() => {
  // daterangepicker cleans up itself when input is removed; nothing needed
});
</script>


